import { IBrand, IBuzzBridgeProfileResponse, ICreateBrand, IGetBuzzBridgeProfile, IInfluencer, types } from './types';
import { createAction } from 'redux-act';
import { IErrorType } from '../../constants/types';
import { IGenericDocumentModifier } from '../../types/global/helper';

// Program actions
export const joinProgram = createAction<any>(types.JOIN_PROGRAM);
export const joinProgramSuccess = createAction<any>(types.JOIN_PROGRAM_SUCCESS);
export const joinProgramFail = createAction<IErrorType>(types.JOIN_PROGRAM_FAIL);

// Campaign actions
export const createOffsiteCampaign = createAction<any>(types.CREATE_OFFSITE_CAMPAIGN);
export const createOffsiteCampaignSuccess = createAction<any>(types.CREATE_OFFSITE_CAMPAIGN_SUCCESS);
export const createOffsiteCampaignFail = createAction<IErrorType>(types.CREATE_OFFSITE_CAMPAIGN_FAIL);

export const requestToJoinCampaign = createAction<any>(types.REQUEST_TO_JOIN_CAMPAIGN);
export const requestToJoinCampaignSuccess = createAction<any>(types.REQUEST_TO_JOIN_CAMPAIGN_SUCCESS);
export const requestToJoinCampaignFail = createAction<IErrorType>(types.REQUEST_TO_JOIN_CAMPAIGN_FAIL);

export const approveCampaignJoinRequest = createAction<any>(types.APPROVE_CAMPAIGN_JOIN_REQUEST);
export const approveCampaignJoinRequestSuccess = createAction<any>(types.APPROVE_CAMPAIGN_JOIN_REQUEST_SUCCESS);
export const approveCampaignJoinRequestFail = createAction<IErrorType>(types.APPROVE_CAMPAIGN_JOIN_REQUEST_FAIL);

export const rejectCampaignJoinRequest = createAction<any>(types.REJECT_CAMPAIGN_JOIN_REQUEST);
export const rejectCampaignJoinRequestSuccess = createAction<any>(types.REJECT_CAMPAIGN_JOIN_REQUEST_SUCCESS);
export const rejectCampaignJoinRequestFail = createAction<IErrorType>(types.REJECT_CAMPAIGN_JOIN_REQUEST_FAIL);

export const getOffsiteCampaignDetails = createAction<any>(types.GET_OFFSITE_CAMPAIGN_DETAILS);
export const getOffsiteCampaignDetailsSuccess = createAction<any>(types.GET_OFFSITE_CAMPAIGN_DETAILS_SUCCESS);
export const getOffsiteCampaignDetailsFail = createAction<IErrorType>(types.GET_OFFSITE_CAMPAIGN_DETAILS_FAIL);

export const getCampaignJobDetails = createAction<any>(types.GET_CAMPAIGN_JOB_DETAILS);
export const getCampaignJobDetailsSuccess = createAction<any>(types.GET_CAMPAIGN_JOB_DETAILS_SUCCESS);
export const getCampaignJobDetailsFail = createAction<IErrorType>(types.GET_CAMPAIGN_JOB_DETAILS_FAIL);

export const manageOffsiteCampaigns = createAction<any>(types.MANAGE_OFFSITE_CAMPAIGNS);
export const manageOffsiteCampaignsSuccess = createAction<any>(types.MANAGE_OFFSITE_CAMPAIGNS_SUCCESS);
export const manageOffsiteCampaignsFail = createAction<IErrorType>(types.MANAGE_OFFSITE_CAMPAIGNS_FAIL);

export const updateOffsiteCampaign = createAction<any>(types.UPDATE_OFFSITE_CAMPAIGN);
export const updateOffsiteCampaignSuccess = createAction<any>(types.UPDATE_OFFSITE_CAMPAIGN_SUCCESS);
export const updateOffsiteCampaignFail = createAction<IErrorType>(types.UPDATE_OFFSITE_CAMPAIGN_FAIL);

export const deleteOffsiteCampaign = createAction<any>(types.DELETE_OFFSITE_CAMPAIGN);
export const deleteOffsiteCampaignSuccess = createAction<any>(types.DELETE_OFFSITE_CAMPAIGN_SUCCESS);
export const deleteOffsiteCampaignFail = createAction<IErrorType>(types.DELETE_OFFSITE_CAMPAIGN_FAIL);

// Brand actions
export const getBrands = createAction<any>(types.GET_BRANDS);
export const getBrandsSuccess = createAction<IBrand[]>(types.GET_BRANDS_SUCCESS);
export const getBrandsFail = createAction<IErrorType>(types.GET_BRANDS_FAIL);

export const addBrand = createAction<ICreateBrand>(types.ADD_BRAND);
export const addBrandSuccess = createAction<IBrand>(types.ADD_BRAND_SUCCESS);
export const addBrandFail = createAction<IErrorType>(types.ADD_BRAND_FAIL);

export const updateBrand = createAction<IGenericDocumentModifier>(types.UPDATE_BRAND);
export const updateBrandSuccess = createAction<any>(types.UPDATE_BRAND_SUCCESS);
export const updateBrandFail = createAction<IErrorType>(types.UPDATE_BRAND_FAIL);

export const deleteBrand = createAction<IGenericDocumentModifier>(types.DELETE_BRAND);
export const deleteBrandSuccess = createAction<any>(types.DELETE_BRAND_SUCCESS);
export const deleteBrandFail = createAction<IErrorType>(types.DELETE_BRAND_FAIL);

// Deliverable actions
export const requestDeliverableUpdate = createAction<any>(types.REQUEST_DELIEVERABLE_UPDATE);
export const requestDeliverableUpdateSuccess = createAction<any>(types.REQUEST_DELIEVERABLE_UPDATE_SUCCESS);
export const requestDeliverableUpdateFail = createAction<IErrorType>(types.REQUEST_DELIEVERABLE_UPDATE_FAIL);

export const approveDeliverableSubmission = createAction<any>(types.APPROVE_DELIVERABLE_SUBMISSION);
export const approveDeliverableSubmissionSuccess = createAction<any>(types.APPROVE_DELIVERABLE_SUBMISSION_SUCCESS);
export const approveDeliverableSubmissionFail = createAction<IErrorType>(types.APPROVE_DELIVERABLE_SUBMISSION_FAIL);

export const uploadDeliverable = createAction<any>(types.UPLOAD_DELIVERABLE);
export const uploadDeliverableSuccess = createAction<any>(types.UPLOAD_DELIVERABLE_SUCCESS);
export const uploadDeliverableFail = createAction<IErrorType>(types.UPLOAD_DELIVERABLE_FAIL);

// Message actions
export const sendCampaignMessage = createAction<any>(types.SEND_CAMPAIGN_MESSAGE);
export const sendCampaignMessageSuccess = createAction<any>(types.SEND_CAMPAIGN_MESSAGE_SUCCESS);
export const sendCampaignMessageFail = createAction<IErrorType>(types.SEND_CAMPAIGN_MESSAGE_FAIL);

export const deleteCampaignMessage = createAction<any>(types.DELETE_CAMPAIGN_MESSAGE);
export const deleteCampaignMessageSuccess = createAction<any>(types.DELETE_CAMPAIGN_MESSAGE_SUCCESS);
export const deleteCampaignMessageFail = createAction<IErrorType>(types.DELETE_CAMPAIGN_MESSAGE_FAIL);

export const updateCampaignMessage = createAction<any>(types.UPDATE_CAMPAIGN_MESSAGE);
export const updateCampaignMessageSuccess = createAction<any>(types.UPDATE_CAMPAIGN_MESSAGE_SUCCESS);
export const updateCampaignMessageFail = createAction<IErrorType>(types.UPDATE_CAMPAIGN_MESSAGE_FAIL);

// Post scheduling actions
export const schedulePost = createAction<any>(types.SCHEDULE_POST);
export const schedulePostSuccess = createAction<any>(types.SCHEDULE_POST_SUCCESS);
export const schedulePostFail = createAction<IErrorType>(types.SCHEDULE_POST_FAIL);

export const getBuzzBridgeProfile = createAction<IGetBuzzBridgeProfile>(types.GET_BUZZBRIDGE_PROFILE);
export const getBuzzBridgeProfileSuccess = createAction<IBuzzBridgeProfileResponse>(
    types.GET_BUZZBRIDGE_PROFILE_SUCCESS,
);
export const getBuzzBridgeProfileFail = createAction<IErrorType>(types.GET_BUZZBRIDGE_PROFILE_FAIL);

export const updateBuzzBridgeProfile = createAction<IGenericDocumentModifier>(types.UPDATE_BUZZBRIDGE_PROFILE);
export const updateBuzzBridgeProfileSuccess = createAction<IInfluencer>(types.UPDATE_BUZZBRIDGE_PROFILE_SUCCESS);
export const updateBuzzBridgeProfileFail = createAction<IErrorType>(types.UPDATE_BUZZBRIDGE_PROFILE_FAIL);
